export const getToken = () => localStorage.getItem("guzz_token");
export const getEmail = () => localStorage.getItem("guzz_email");
export const setAuth = (token, email) => {
  localStorage.setItem("guzz_token", token);
  localStorage.setItem("guzz_email", email);
};
export const clearAuth = () => {
  localStorage.removeItem("guzz_token");
  localStorage.removeItem("guzz_email");
};
export const isAuthenticated = () => !!getToken();
